// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const rolePolicyEditor = {
  id: "policy-editor",
  mrn: "//iam.api.mondoo.app/roles/policy-editor",
  title: "Policy Editor",
  allowedActions,
} as const;

export type RolePolicyEditor = typeof rolePolicyEditor;
